import React from 'react';
import { Link } from 'react-router-dom';
import FloatingCTA from '../components/FloatingCTA';
import './AllInX.css';

function AllInX() {
  return (
    <div className="allinx-page" data-testid="allinx-page">
      <FloatingCTA />
      
      <section className="page-hero">
        <div className="container">
          <div className="hero-text">
            <h1>Willkommen bei All InX</h1>
            <p className="hero-subtitle">...deinem Tor in die Zukunft der digitalen Vermögenswerte!</p>
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section className="videos-section section">
        <div className="container">
          <div className="videos-grid">
            <div className="video-card">
              <h3>All InX im Überblick</h3>
              <div className="video-wrapper">
                <iframe
                  src="https://player.vimeo.com/video/1133588068?badge=0&autopause=0&player_id=0&app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  title="All InX im Überblick"
                  className="vimeo-iframe"
                ></iframe>
              </div>
            </div>

            <div className="video-card">
              <h3>Deep Dive mit dem All InX CMO Mike</h3>
              <div className="video-wrapper">
                <iframe
                  src="https://player.vimeo.com/video/1130417547?badge=0&autopause=0&player_id=0&app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  title="Deep Dive mit dem All InX CMO Mike"
                  className="vimeo-iframe"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="content-section section">
        <div className="container">
          <div className="content-wrapper">
            <p>
              In einer Welt, die sich immer schneller wandelt, bietet All InX eine innovative Plattform, die den Zugang zu neuen Investmentmöglichkeiten revolutioniert. Ob du Anfänger bist oder schon Erfahrung hast – hier findest du einfache, sichere und zukunftsweisende Lösungen, um dein Portfolio zu erweitern.
            </p>

            <p>
              Erkunde die spannende Welt der Tokenisierung, blockchainbasierter Technologien und innovativer Finanzkonzepte. Der Markt für reale Vermögenswerte (RWA) integriert echte Werte auf der Blockchain und schafft so eine stabile Basis für dein Investment.
            </p>

            <div className="highlight-box">
              <p className="highlight-stat">
                Laut Bloomberg-Bericht beträgt die potenzielle Marktgröße für die RWA-Tokenisierung bis zu<br /><strong>16 Billionen US-Dollar.</strong>
              </p>
            </div>

            {/* Rotating All InX Logo */}
            <div className="rotating-logo-section">
              <img 
                src="https://customer-assets.emergentagent.com/job_e5c77d79-ca13-402d-b554-25dcc110651b/artifacts/h6c86k60_AllinX%20transparent.png"
                alt="All InX Logo"
                className="rotating-logo"
              />
            </div>

            <p>
              Lass dich von einer starken Gemeinschaft und modernster Technik begeistern und entdecke, wie du mit All InX nicht nur investierst, sondern aktiv die Zukunft mitgestaltest.
            </p>

            <div className="feature-box">
              <h3>🎁 Krypto-Debitkarte ohne KYC</h3>
              <p>
                Ein weiteres Highlight ist die Krypto-Debitkarte ohne KYC. Dein Förderer kann dir dazu gerne mehr Informationen geben. Ein echtes Plus, das sich auf jeden Fall lohnt!
              </p>
            </div>

            <p className="cta-text">
              Bereit, mehr zu erfahren? Lass uns diesen Weg gemeinsam gehen!
            </p>

            <div className="repository-link-box">
              <h3>All InX Repository</h3>
              <p>Hier findest du alle wichtigen Informationen und Ressourcen:</p>
              <a 
                href="https://repository.allinx.io/de-page" 
                target="_blank" 
                rel="noopener noreferrer"
                className="repository-link"
              >
                🔗 https://repository.allinx.io/de-page
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2>Bereit, den ersten Schritt zu machen?</h2>
            <p>Werde Teil unserer Gemeinschaft und starte deine Reise zur finanziellen Freiheit.</p>
            <div className="qr-code-container">
              <a 
                href="/#cta-section" 
                className="qr-code-link"
                data-testid="foerderer-cta-link"
              >
                Jetzt persönlichen Förderer finden →
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AllInX;
